module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 265,
	"w": 1200,
	"h": 1200,
	"nm": "Content Commerce Spin",
	"ddd": 1,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 1,
			"ind": 1,
			"ty": 5,
			"nm": "CONTENT",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 0,
					"k": 0,
					"ix": 9,
					"x": "var $bm_rt;\n$bm_rt = thisComp.layer('Shape Layer 1').transform.yRotation;"
				},
				"rz": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 0,
					"k": [
						600.074,
						606.702,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-163,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"sz": [
									964,
									124
								],
								"ps": [
									-482,
									-226
								],
								"s": 162,
								"f": "LabilGrotesk-Bold",
								"t": "CONTENT",
								"j": 2,
								"tr": 0,
								"lh": 194.4,
								"ls": 0,
								"fc": [
									0.949,
									0.941,
									0.89
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 132,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 1,
			"ind": 2,
			"ty": 5,
			"nm": "COMMERCE",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 0,
					"k": 0,
					"ix": 9,
					"x": "var $bm_rt;\n$bm_rt = $bm_sum(thisComp.layer('Shape Layer 1').transform.yRotation, 180);"
				},
				"rz": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 0,
					"k": [
						600.074,
						606.702,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-163,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"sz": [
									964,
									124
								],
								"ps": [
									-482,
									-226
								],
								"s": 162,
								"f": "LabilGrotesk-Bold",
								"t": "COMMERCE",
								"j": 2,
								"tr": 0,
								"lh": 194.4,
								"ls": 0,
								"fc": [
									0.949,
									0.941,
									0.89
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 132,
			"op": 265,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 1,
			"ind": 3,
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 0,
							"s": [
								-90
							]
						},
						{
							"t": 264,
							"s": [
								270
							]
						}
					],
					"ix": 9
				},
				"rz": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 0,
					"k": [
						600,
						600,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						150.617,
						150.617,
						150.617
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											200.121,
											0
										],
										[
											0,
											-200.121
										],
										[
											-200.121,
											0
										],
										[
											0,
											200.121
										]
									],
									"o": [
										[
											-200.121,
											0
										],
										[
											0,
											200.121
										],
										[
											200.121,
											0
										],
										[
											0,
											-200.121
										]
									],
									"v": [
										[
											0,
											-362.352
										],
										[
											-362.352,
											0
										],
										[
											0,
											362.352
										],
										[
											362.352,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.949019607843,
									0.941176470588,
									0.890196078431,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 908,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "C",
			"size": 162,
			"style": "Bold",
			"w": 77.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.645,
												0
											],
											[
												-0.201,
												16.818
											],
											[
												0,
												0
											],
											[
												10.373,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.884,
												0
											],
											[
												-0.403,
												-9.467
											],
											[
												0,
												0
											],
											[
												19.135,
												0
											],
											[
												0,
												-20.847
											]
										],
										"o": [
											[
												19.235,
												0
											],
											[
												0,
												0
											],
											[
												-0.604,
												9.869
											],
											[
												-12.085,
												0
											],
											[
												0,
												-13.495
											],
											[
												10.675,
												0
											],
											[
												0,
												0
											],
											[
												-0.302,
												-16.617
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												39.981,
												1.913
											],
											[
												74.524,
												-27.997
											],
											[
												58.813,
												-29.205
											],
											[
												39.981,
												-12.589
											],
											[
												19.537,
												-35.248
											],
											[
												39.981,
												-58.109
											],
											[
												58.813,
												-41.895
											],
											[
												74.625,
												-43.204
											],
											[
												39.981,
												-72.409
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "C",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "O",
			"size": 162,
			"style": "Bold",
			"w": 80.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.847,
												0
											],
											[
												0,
												20.847
											],
											[
												20.847,
												0
											],
											[
												0,
												-20.746
											]
										],
										"o": [
											[
												21.048,
												0
											],
											[
												0,
												-21.048
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												40.384,
												2.014
											],
											[
												77.646,
												-35.248
											],
											[
												40.384,
												-72.51
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												11.581,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.581,
												0
											],
											[
												0,
												-13.293
											]
										],
										"o": [
											[
												-11.783,
												0
											],
											[
												0,
												-13.495
											],
											[
												11.783,
												0
											],
											[
												0,
												13.394
											]
										],
										"v": [
											[
												40.384,
												-12.488
											],
											[
												19.537,
												-35.248
											],
											[
												40.384,
												-58.109
											],
											[
												61.23,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "O",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "M",
			"size": 162,
			"style": "Bold",
			"w": 88.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.746,
												0
											],
											[
												19.739,
												-50.253
											],
											[
												36.255,
												0
											],
											[
												52.57,
												0
											],
											[
												69.186,
												-50.253
											],
											[
												68.179,
												0
											],
											[
												83.89,
												0
											],
											[
												83.89,
												-70.496
											],
											[
												61.533,
												-70.496
											],
											[
												44.513,
												-16.315
											],
											[
												27.594,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "M",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "M",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "E",
			"size": 162,
			"style": "Bold",
			"w": 58.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												55.087,
												0
											],
											[
												55.087,
												-12.891
											],
											[
												21.35,
												-12.891
											],
											[
												21.35,
												-29.608
											],
											[
												51.059,
												-29.608
											],
											[
												51.059,
												-41.592
											],
											[
												21.35,
												-41.592
											],
											[
												21.35,
												-57.806
											],
											[
												54.684,
												-57.806
											],
											[
												54.684,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "E",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "R",
			"size": 162,
			"style": "Bold",
			"w": 64.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.403,
												-6.143
											],
											[
												0,
												0
											],
											[
												-0.604,
												-1.611
											],
											[
												0,
												0
											],
											[
												0.201,
												3.323
											],
											[
												0,
												0
											],
											[
												9.567,
												0.705
											],
											[
												0,
												9.467
											],
											[
												15.61,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												6.345,
												0
											],
											[
												0,
												0
											],
											[
												0.201,
												2.115
											],
											[
												0,
												0
											],
											[
												-0.806,
												-1.813
											],
											[
												0,
												0
											],
											[
												-0.504,
												-8.56
											],
											[
												10.776,
												-1.108
											],
											[
												0,
												-12.689
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.149,
												0
											],
											[
												21.149,
												-23.566
											],
											[
												32.529,
												-23.566
											],
											[
												42.599,
												-15.408
											],
											[
												43.204,
												-5.942
											],
											[
												44.312,
												0
											],
											[
												60.626,
												0
											],
											[
												59.317,
												-7.15
											],
											[
												58.713,
												-16.617
											],
											[
												44.211,
												-31.018
											],
											[
												62.64,
												-49.045
											],
											[
												36.154,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-6.345
											],
											[
												6.546,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												6.445,
												0
											],
											[
												0,
												6.244
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.149,
												-36.255
											],
											[
												21.149,
												-57.605
											],
											[
												35.349,
												-57.605
											],
											[
												46.326,
												-46.93
											],
											[
												35.147,
												-36.255
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "R",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "N",
			"size": 162,
			"style": "Bold",
			"w": 71.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.041,
												-47.534
											],
											[
												50.354,
												0
											],
											[
												66.769,
												0
											],
											[
												66.769,
												-70.496
											],
											[
												50.958,
												-70.496
											],
											[
												51.764,
												-22.961
											],
											[
												21.451,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "N",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "T",
			"size": 162,
			"style": "Bold",
			"w": 60,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												22.055,
												0
											],
											[
												38.37,
												0
											],
											[
												38.37,
												-57.605
											],
											[
												58.109,
												-57.605
											],
											[
												58.109,
												-70.496
											],
											[
												2.316,
												-70.496
											],
											[
												2.316,
												-57.605
											],
											[
												22.055,
												-57.605
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "T",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Content Commerce Spin.json
// module id = 42
// module chunks = 0